/**
 * Wann ich an einer Aufgabe arbeite (F-06) - getrennt von der Deadline.
 *
 * Nur ein Datum: die Aufgabe steht an diesem Tag oben im Kalender. Mit
 * Uhrzeit wird sie ein Block im Stundenraster, mit der gewaehlten Dauer.
 */
import { X } from 'lucide-react';

import { Input } from '@/ui/primitives/Input';
import type { LocalDate } from '@/domain/types';

export interface PlanWert {
  date: LocalDate | '';
  start: string;
  minutes: number;
}

const DAUERN = [15, 30, 45, 60, 90, 120, 180];

export function PlanFeld({ value, onChange }: { value: PlanWert; onChange: (v: PlanWert) => void }) {
  const dauern = DAUERN.includes(value.minutes) ? DAUERN : [...DAUERN, value.minutes].sort((a, b) => a - b);
  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Breiten ueber Huellen: Input bringt w-full mit, cn fuehrt nicht zusammen. */}
      <div className="min-w-36 flex-1">
        <Input
          type="date"
          value={value.date}
          onChange={(e) => onChange({ ...value, date: e.target.value as LocalDate | '', start: e.target.value ? value.start : '' })}
          aria-label="Eingeplant am"
        />
      </div>
      <div className="w-28 shrink-0">
        <Input
          type="time"
          value={value.start}
          disabled={!value.date}
          onChange={(e) => onChange({ ...value, start: e.target.value })}
          aria-label="Eingeplant um (optional)"
          title="Uhrzeit (optional) – mit Uhrzeit wird die Aufgabe ein Block im Kalender"
        />
      </div>
      <select
        value={value.minutes}
        disabled={!value.start}
        onChange={(e) => onChange({ ...value, minutes: Number(e.target.value) })}
        aria-label="Dauer"
        className="h-9 shrink-0 rounded-md border border-line bg-surface px-2 text-sm text-ink disabled:opacity-50"
      >
        {dauern.map((m) => (
          <option key={m} value={m}>{m < 60 ? `${m} min` : `${m / 60} h`.replace('.', ',')}</option>
        ))}
      </select>
      {value.date && (
        <button
          type="button"
          onClick={() => onChange({ ...value, date: '', start: '' })}
          aria-label="Einplanung entfernen"
          title="Einplanung entfernen"
          className="grid size-9 shrink-0 place-items-center rounded-md text-ink-faint hover:bg-surface-raised hover:text-ink"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}
